import React from 'react';
import { SectionSubtitle, SectionTitle } from '../SectionText';
import { useLocale } from 'locale';
import styled from '@emotion/styled';
import { useImageUrlBuilder } from 'hooks/useImageUrlBuilder';
import { BadgeItem } from './BadgeItem';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    gap: ${theme.spacing(4)};
  `}
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    flex-direction: row;
    gap: ${theme.spacing(3)};
  `}
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const BadgesSection: React.FC = () => {
  const { t } = useLocale();
  const constructImageURI = useImageUrlBuilder();

  return (
    <Wrapper>
      <Title>
        <SectionTitle weight="bold">
          {t('madad.2026.badges.title')}
        </SectionTitle>
        <SectionSubtitle>
          {t('madad.2026.badges.subtitle')}
        </SectionSubtitle>
      </Title>
      <ItemsWrapper>
        <BadgeItem
          title={t('madad.2026.top10Gold.title')}
          subtitle={t('madad.2026.top10Gold.subtitle')}
          image={<img width={200} src={constructImageURI('madad/2026/top10Gold.webp', { width: 400 })} alt={t('madad.2026.top10Gold.title')} />}
        />
        <BadgeItem
          title={t('madad.2026.top10.title')}
          subtitle={t('madad.2026.top10.subtitle')}
          image={<img width={200} src={constructImageURI('madad/2026/top10.webp', { width: 400 })} alt={t('madad.2026.top10.title')} />}
        />
      </ItemsWrapper>
    </Wrapper>
  );
};
